import type { Bitmap } from "../bitmap/types.ts";
import type { BuildBitmap } from "../model/index.ts";

type BuildInput = Bitmap | BuildBitmap;

function normaliseBuildInput(input: BuildInput): BuildBitmap {
	if ("noBrickColour" in input) {
		return input;
	}
	return { noBrickColour: undefined, ...input };
}

export { normaliseBuildInput };
export type { BuildInput };
